<template>
    <v-container fluid>
        <template>
            <h1>Formulas</h1>
            <router-view></router-view>
        </template>
    </v-container>
</template>

<script>
export default {
    data: () => ({
    }),
}
</script>